import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { UserContext } from '../context/UserContext';

// The avatar's menu where the rest of the app is out of reach (onboarding): who is
// signed in, and a way out to sign in with a different account.
const AccountMenu = ({ children }) => {
  const { user, logout } = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
    } finally {
      setIsLoggingOut(false);
      setAnchorEl(null);
    }
  };

  return (
    <>
      <button
        type="button"
        aria-label="תפריט חשבון"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        onClick={event => setAnchorEl(event.currentTarget)}
        style={{ padding: 0, border: 0, background: 'transparent', cursor: 'pointer' }}
      >
        {children}
      </button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { sx: { minWidth: 220, mt: 1, direction: 'rtl' } } }}
      >
        <div style={{ padding: '6px 16px 10px', textAlign: 'right' }}>
          <div style={{ fontWeight: 'bold', color: '#0d3259' }}>{user?.name}</div>
          {user?.email && <div style={{ fontSize: 13, color: '#526579' }}>{user.email}</div>}
        </div>
        <Divider />
        <MenuItem onClick={handleLogout} disabled={isLoggingOut}>
          <ListItemIcon sx={{ color: '#0d3259' }}>
            <FontAwesomeIcon icon={faRightFromBracket} flip="horizontal" />
          </ListItemIcon>
          <ListItemText sx={{ textAlign: 'right' }}>
            {isLoggingOut ? 'מתנתק...' : 'התנתקות'}
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

AccountMenu.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AccountMenu;
